/**
 * Labstep
 *
 * @module components/Tag/Filter/Status/Active
 * @desc Active filter component for status
 */

import { tagTypes } from 'labstep-web/components/Tag/Form/fields';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import type React from 'react';
import type { ITagFilterTypeActiveProps } from './types';

export const TagFilterTypeActive: React.FC<
  ITagFilterTypeActiveProps
> = ({ clearParams, searchParams }) =>
  'type' in searchParams ? (
    <RemoveLabel
      name={`${
        tagTypes[searchParams.type as keyof typeof tagTypes]
      } Tags`}
      onRemoveClick={clearParams && (() => clearParams(['type']))}
    />
  ) : null;
